import React, { FC, useState } from 'react'

// Constants
import { MAX_SEATS_VALUE } from '../../constants'

// Components
import Stepper from 'components/Stepper'

// Styles
import { Wrapper, Text } from './AddEditors.styles'

// Local constants
const MIN_SEATS_VALUE = 1

// Types
interface AddEditorsProps {
  seats: number
  onChange: (value: number) => void
}

const AddEditors: FC<AddEditorsProps> = ({ seats, onChange }) => {
  const [newSeats, setNewSeats] = useState(seats || MIN_SEATS_VALUE)

  const handleChange = (value: number) => [setNewSeats(value), onChange(value)]

  return (
    <Wrapper>
      <Text>Bring more Editors into the Workspace</Text>
      <Stepper
        value={newSeats}
        onChange={handleChange}
        min={MIN_SEATS_VALUE}
        max={MAX_SEATS_VALUE}
      />
    </Wrapper>
  )
}

export default AddEditors
